import { render } from "./ProjectTitleSection.vue?vue&type=template&id=cbe2b858&ts=true"
import script from "./ProjectTitleSection.vue?vue&type=script&lang=ts"
export * from "./ProjectTitleSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__